import { ReactNode } from "react";

import Box from "../Box";
import { TypographyProps } from "../Typography";
import PageInfoHeaderTitle from "./Title";
import PageInfoHeaderWrapper from "./Wrapper";
import PageInfoHeaderActions from "./Actions";
import PageInfoHeaderCaption from "./Caption";

type PageInfoHeaderProps = {
  title: ReactNode;
  children?: ReactNode;
  titleTag?: TypographyProps["tag"];
  caption?: string;
  captionTag?: TypographyProps["tag"];
  fullWidthTitle?: boolean;
};

const PageInfoHeader = ({
  title,
  children,
  titleTag = "h2",
  caption,
  captionTag = "p",
  fullWidthTitle = false,
}: PageInfoHeaderProps) => (
  <PageInfoHeaderWrapper>
    <Box direction="column" fullWidth={fullWidthTitle}>
      <PageInfoHeaderTitle title={title} titleTag={titleTag} />
      {caption && <PageInfoHeaderCaption caption={caption} captionTag={captionTag} />}
    </Box>
    {children && <PageInfoHeaderActions>{children}</PageInfoHeaderActions>}
  </PageInfoHeaderWrapper>
);

PageInfoHeader.displayName = "DS.PageInfoHeader";

export default PageInfoHeader;
